module.exports = __webpack_public_path__ + "img/561c8b4.png";